export enum ProfileViewMode {
    EDIT = 'EDIT',
    READ_ONLY = 'READ_ONLY',
}

export interface OwnerTypeState {
    Id: string;
    Name: string;
    LocalizedCaption: string;
    Caption: string;
    __isAdded?: boolean;
    __isChanged?: boolean;
    Deleted?: boolean;
}

export interface ContactState {
    Id: string;
    ContactType: string;
    EntityId: number;
    EntityName: string;
    Name: string;
    Email: string;
    Phone: string;
    Position: string;
    ResponseTime: string;
    Notes: string;
    __isAdded?: boolean;
    __isChanged?: boolean;
    Deleted?: boolean;
}

export const editableContactFields = [
    'Name',
    'Email',
    'Phone',
    'Position',
    'ContactType',
    'ResponseTime',
    'Notes',
] as const;

export type EditableContactField = (typeof editableContactFields)[number];

export interface AccountInformationState {
    Id: string;
    Name: string;
    Email: string;
    ContactPerson: string;
    Phone: string;
    IdOwnerType: number;
    OwnerType: string;
    OwnerTypes: OwnerTypeState[];
    IdCountry: number;
    Country: string;
    CountryCode: string;
    DateSigned: Date | null;
    HotelChain: string;
    IdCurrency: number;
    Currency: string;
    Contacts: ContactState[];
}
